import {MDIcon} from '@mintdata-wsp/common/components/icon/MDIcon';
import {MDIcons} from '@mintdata-wsp/common/components/icon/MDIcons';
import {Project} from '@mintdata-wsp/common/state/DataState';
import {rootState} from '@mintdata-wsp/common/state/RootState';
import {PopupAnchor, SourceAnchor} from '@mintdata-wsp/mint-kit/impl/components/popover/PopupTypes';
import {Tooltip} from '@mintdata-wsp/mint-kit/impl/components/tooltip/Tooltip';
import {Dialogs} from '@mintdata-wsp/wsp/controllers/common/DialogsController';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {SidebarLink} from '@mintdata-wsp/wsp/ui/views/workspace/home/sidebar/SidebarLink';
import {SidebarSpacesItem} from '@mintdata-wsp/wsp/ui/views/workspace/home/sidebar/spaces/SidebarSpacesItem';
import {WspSidebarLink} from '@mintdata-wsp/wsp/ui/views/workspace/home/sidebar/WspSidebar';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./SidebarSpaces.less');
const cx = classnames.bind(styles);

@observer
export class SidebarSpaces extends React.Component<any, any>
{
    private _spaceRefs:Map<number,HTMLElement> = new Map();

    private onClickAddSpace = () => controllers.ui.dialogs.showDialog(Dialogs.AddSpace, false);

    private _onSpaceItemRef = (projectId, elementRef:HTMLElement) => this._spaceRefs.set(projectId, elementRef);

    componentDidUpdate()
    {
        const {currentProject} = rootState.ui.mainPage;

        if( currentProject && this._spaceRefs.has(currentProject.id) && this._spaceRefs.get(currentProject.id) !== null )
            this._spaceRefs.get(currentProject.id).scrollIntoView({block: 'center'});
    }

    render():JSX.Element
    {
        // do not remove: need for update component
        const {locationMatch, currentProject} = rootState.ui.mainPage;

        const {projects} = rootState.data;

        return (
            <div className={cx(styles.spacesWrapper,
                {minHeightFor0: projects.length === 0},
                {minHeightFor1: projects.length === 1},
                {minHeightFor2: projects.length === 2},
            )}>

                <div className={styles.header}>
                    <SidebarLink
                        sidebarLink={WspSidebarLink.SPACES}
                        className={styles.spacesLinkBold}
                        wrapperClassName={styles.linkInHeader}
                        iconClassName={styles.spacesLinkIcon}
                    />
                    <Tooltip
                        tooltipClassName={cx('tooltip')}
                        showArrow={false}
                        closeOnTargetClick={true}
                        content={'New space'}
                        popoverProps={{
                            className: cx('tooltipPopover'),
                            sourceAnchor: SourceAnchor.CenterBottom,
                            popupAnchor: PopupAnchor.CenterTop,
                            ignoreEsc: true
                        }}
                        hoverOpenDelay={300}
                    >
                        <div
                            className={styles.btnAdd}
                            onClick={this.onClickAddSpace}
                        >
                            <MDIcon
                                className={styles.btnIcon}
                                name={MDIcons.common.Add}
                            />
                        </div>
                    </Tooltip>
                </div>

                <div className={styles.spaces}>
                    {
                        projects.map((project:Project) =>
                        {
                            return (
                                <SidebarSpacesItem
                                    onRef={this._onSpaceItemRef}
                                    key={project.id}
                                    project={project}
                                />
                            );
                        })
                    }
                </div>

            </div>
        );
    }
}
